<template>
    <div id="cover" class="position d-flex flex-column" :class="coverClass" :style="coverStyle">
        <div class="w-100 header-position" :class="customHeaderButtonClass" v-if="!disable">
            <span class="badge badge-pill badge-light w-100 mb-1" @click="isOpen=!isOpen">
                <i class="fa m-auto" aria-hidden="true" :class="buttonIcon"></i>
            </span>
        </div>
        <div :class="slotClass" class="slot-show flex-grow-1" id="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "DrawerHandler",
    props: {
        isLeft: {
            type: Boolean,
            default: false
        },
        isTop: {
            type: Boolean,
            default: false
        },
        isBottom: {
            type: Boolean,
            default: false
        },
        closeWidth: {
            type: Number,
            default: 1.8
        },
        openWidth: {
            type: Number,
            default: 19
        },
        toInvisible: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        customHeaderButtonClass: {
            type: String,
            default: 'bg-normal'
        }
    },
    computed: {
        coverClass() {
            let temp = [];
            if (this.isLeft) {
                temp.push('left');
            } else if (this.isTop) {
                temp.push('top');
            } else if (this.isBottom) {
                temp.push('bottom');
            } else {
                temp.push('right');
            }
            return temp.join(" ");
        },
        coverStyle() {
            let temp = [];
            let length = this.disable ? '100%' : ((this.isOpen ? this.openWidth : this.closeWidth) + 'rem');
            if (this.isVertical) {
                temp.push('max-width: 100%');
                temp.push('height: ' + length);
            } else {
                temp.push('max-height: 100%');
                temp.push('max-width: ' + length);
            }
            return temp.join(";");
        },
        isVertical() {
            return this.isTop || this.isBottom;
        },
        buttonIcon() {
            let open = this.isVertical ? this.iconDown : this.iconRight;
            let close = this.isVertical ? this.iconUp : this.iconLeft;
            return (this.isLeft || this.isTop) ^ this.isOpen ? open : close;
        },
        slotClass() {
            let temp = [];
            temp.push(!this.toInvisible || this.isOpen ? 'show' : 'hide');
            temp.push(this.isVertical ? 'w-100' : 'h-100');
            return temp.join(" ");
        },
    },
    data() {
        return {
            iconLeft: 'fa-angle-left',
            iconRight: 'fa-angle-right',
            iconDown: 'fa-angle-down',
            iconUp: 'fa-angle-up',
            isOpen: true
        }
    },
    watch: {
        isOpen(val) {
            this.$emit('open', val);
            setTimeout(() => this.$emit('toggle'), 300);
        }
    },
    methods: {
        toggle(val) {
            this.isOpen = val === undefined ? !this.isOpen : val;
        },
        clientHeight() {
            let cover = document.getElementById('cover');
            if (cover && cover.clientHeight) {
                return cover.clientHeight;
            } else {
                return '0px';
            }
        },
        /**
         * @example
         *          <div :style="$refs.drawer ? $refs.drawer.anotherFixedHeight() : ''"/>
         *          <drawer-handler ref="drawer" isBottom/>
         */
        anotherFixedHeight(heightRate = 100) {
            if (!this.isVertical) {
                return '';
            }
            return `height: calc(${heightRate}vh - ${this.clientHeight()});transition: height .3s ease-out;`;
        },
    }
}
</script>

<style scoped>
.position {
    position: relative;
    overflow: auto;
    transition: max-width .3s ease-out, height .3s ease-out;
}

.position::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}

.show {
    opacity: 1;
}

.hide {
    opacity: 0;
}

.slot-show {
    overflow: auto;
    transition: opacity .3s ease-out;
}

.header-position {
    position: sticky;
    top: 0;
    z-index: 100;
}

#container::-webkit-scrollbar {
    width: 1px;
    background-color: transparent;
}

#container::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background-color: gray;
}
</style>